import jQuery from "jquery";

export default () => {

    jQuery(document).ready(function ($) {

        // Table of contents
        const $tocDropdown = $('#titled-menu');
        const $tocOpen = $('.article-contents > nav');
        const $tocClass = $('.article-contents');

        $(document).mouseup(e => {
            if (!$tocDropdown.is(e.target) && $tocDropdown.has(e.target).length === 0) {
                $tocClass.removeClass('open close');
            }
        });
        $tocDropdown.on('click', () => {
            $tocOpen.toggle('slow');
            $tocClass.toggleClass('open close');
        });


        // Footer mobile dropdown
        const $dropdown2 = $('.dropdown-2 > h4');
        const $dropdown3 = $('.dropdown-3 > h4');
        const $dropdown4 = $('.dropdown-4 > h4');
        const $dropdown5 = $('.dropdown-5 > h4');

        if ( $(window).width() <= 768 ) {
            $dropdown2.on('click', () => {
                $dropdown2.next().toggle('slow');
                $dropdown2.toggleClass('open close');
            });
            $dropdown3.on('click', () => {
                $dropdown3.next().toggle('slow');
                $dropdown3.toggleClass('open close');
            });
            $dropdown4.on('click', () => {
                $dropdown4.next().toggle('slow');
                $dropdown4.toggleClass('open close');
            });
            $dropdown5.on('click', () => {
                $dropdown5.next().toggle('slow');
                $dropdown5.toggleClass('open close');
            });
        }
    });

}